var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',_vm._l((_vm.dependencyConnectors),function(connector,key){return _c('SvgBridgeConnector',{key:key,attrs:{"sx":connector.sx,"sy":connector.sy,"ex":connector.ex,"ey":connector.ey,"selected":_vm.selectedDependencyConnector[key]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }